var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.items.length
    ? _c(
        "div",
        { staticClass: "core-image-slider" },
        [
          _c(_setup.CoreImageLightbox, {
            ref: "lightboxRef",
            attrs: { items: _setup.items },
          }),
          _vm._v(" "),
          _c(_setup.CoreSwiper, {
            staticClass: "core-image-slider__swiper",
            attrs: {
              "slides-per-view": _setup.slidesPerView,
              "space-between": _setup.spaceBetween,
              "has-navigation": _setup.showNavigation,
              "has-pagination": _setup.showPagination,
              "free-mode": _vm.freeMode,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "slides",
                  fn: function ({ slideAttrs }) {
                    return _vm._l(_setup.items, function (item, index) {
                      return _c(
                        "div",
                        _vm._b(
                          { key: `${item.id ?? item.src}-${index}` },
                          "div",
                          slideAttrs,
                          false
                        ),
                        [
                          _vm._t(
                            "item",
                            function () {
                              return [
                                _c(
                                  "article",
                                  { staticClass: "core-image-slider__item" },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "core-image-slider__preview",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _setup.open(index)
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass:
                                            "core-image-slider__image",
                                          attrs: {
                                            src: item.previewSrc || item.src,
                                            alt: item.alt || item.title || "",
                                            title: item.title || undefined,
                                            loading: "lazy",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                            {
                              item: item,
                              index: index,
                              open: () => _setup.open(index),
                            }
                          ),
                        ],
                        2
                      )
                    })
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }